import React, { CSSProperties } from "react";
import ct from "class-types.macro";

interface Props {
  forward: () => void;
  className?: ClassTypes;
  inlineStyle?: CSSProperties;
  text?: string;
}

const ContinueButton = ({ forward, className, inlineStyle, text }: Props) => {
  return (
    <button
      type="button"
      style={inlineStyle}
      className={`${ct("ml-4", "py-1", "px-5")} btn btn-primary ${className}`}
      onClick={forward}
    >
      {text || "Continue"}
    </button>
  );
};

export default ContinueButton;
